module.exports = __webpack_public_path__ + "static/img/dev_2.5f15dbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/about-us/dev_2.svg
// module id = bLL+
// module chunks = 1